import { DocsTabItem } from '../types';
import { DocumentationTab } from '../api/types';
import { DOCS_V2_BASE_ROUTE } from '../api/documentationApi';

export function normalizeDocumentTagName(
  documentTagName: string | undefined,
): string {
  return (documentTagName ?? '')
    .split('/')
    .filter(Boolean)
    .map(decodeDocumentTagSegment)
    .join('/');
}

export function getDocumentationRoute(
  documentTagName: string,
): string {
  const normalizedDocumentTagName =
    normalizeDocumentTagName(documentTagName);

  if (!normalizedDocumentTagName) {
    return DOCS_V2_BASE_ROUTE;
  }

  const encodedDocumentTagName = normalizedDocumentTagName
    .split('/')
    .map(encodeURIComponent)
    .join('/');

  return `${DOCS_V2_BASE_ROUTE}/${encodedDocumentTagName}`;
}

export function mapDocumentationTabToDocsTabItem(
  tab: DocumentationTab,
): DocsTabItem {
  return {
    id: tab.documentTagName,
    label: tab.title,
  };
}

export function isDocumentTagWithinTab(
  documentTagName: string,
  tabDocumentTagName: string,
): boolean {
  return (
    documentTagName === tabDocumentTagName ||
    documentTagName.startsWith(`${tabDocumentTagName}/`)
  );
}

function decodeDocumentTagSegment(documentTagSegment: string): string {
  try {
    return decodeURIComponent(documentTagSegment);
  } catch {
    return documentTagSegment;
  }
}
